// Shortlist: Entry
// 

JLM.MD.MenuShortlistEntry = function( container, talent_info, division_type ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let item, figure;
	
	
	
	// Variables: Public ________________________________________________________
	
	INSTANCE.id = talent_info[0];
	INSTANCE.name = talent_info[1];
	INSTANCE.images = talent_info[2];
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		let link, title, but_remove;
		
		// Create structure
		item = $('<li />').appendTo( container );
		link = $('<a />').appendTo( item );
		figure = $('<figure />').appendTo( link );
		but_remove = $('<button type="button"><svg class="icon"><use xlink:href="#jl_icon_remove"></use></svg></button>').appendTo( figure );
		title = $('<h6>' + INSTANCE.name + '</h6>').appendTo( link );
		
		// Set link
		let talent_link = JLM.MT.generateTalentProfileLink(division_type, INSTANCE.name);
		link.attr('href', talent_link);
		
		// Events
		link.on('click', onClickLink);
		but_remove.on('click', onClickRemove);
		
		// Load image
		let image_src = '/img/' + INSTANCE.id + '/thmb/1/' + INSTANCE.images[ division_type ];
		loadImage( image_src );
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Event: Link click
	// 
	function onClickLink( event ) {
		INSTANCE.dispatchEvent('click');
		// event.preventDefault();
	}
	
	
	// Event: Button click
	// 
	function onClickRemove( event ) {
		INSTANCE.remove();
		INSTANCE.dispatchEvent('remove', [ INSTANCE.id ]);
		event.preventDefault();
	}
	
	
	// Load image process
	// 
	function loadImage( image_src ) {
		let image = new Image();
		image.onload = function() {
			let image_span = $('<span />').css('background-image', 'url(' + image_src + ')').appendTo( figure );
			setTimeout(function() {
				image_span.addClass('reveal');
			}, 10);
		};
		image.onerror = function() {
			// Fallback image?
		};
		image.src = image_src;
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Remove item
	// 
	INSTANCE.remove = function() {
		item.remove();
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};